export const ORDER_ID_HELPER = 'Re-points webhooks, poll, PDF, and adjudication to the new Connect order.';

export const UPDATE_ORDER_DESCRIPTION =
  'Enter the new Connect order ID. An internal note with the old → new change and who made it will be created.';

export const UPDATE_ORDER_INFO =
  'Webhooks and poll will use the new ID. PDF download, cleaning, and adjudication stay automated.';
